import { HalfImageHalfText } from "./HalfImageHalfText";

export const UniversalRender = HalfImageHalfText;
